import React, { useMemo } from "react";
import { InputForm } from "components/inputs";
import useInputType from "hooks/useInputType";
import { createInput as createInputRequest } from "hooks/useInputs";
import useHistory from "routing/useHistory";
import Routes from "routing/Routes";
export const ExternalDataLakeInputType = "org.graylog.plugins.datalake.externaldatalake.input.ExternalDataLakeInput";
const DataLakeConnectorCreateInputModal = ({
  connectorId = void 0,
  tableId = void 0,
  filterQuery = void 0,
  filterQueryOperator = void 0,
  onClose
}) => {
  const history = useHistory();
  const { data: inputDefinition } = useInputType(ExternalDataLakeInputType);
  const externalDataLakeInputFields = useMemo(
    () => {
      var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l;
      return (inputDefinition == null ? void 0 : inputDefinition.requested_configuration) ? {
        ...inputDefinition == null ? void 0 : inputDefinition.requested_configuration,
        athena_connector: {
          ...(_a = inputDefinition == null ? void 0 : inputDefinition.requested_configuration) == null ? void 0 : _a.athena_connector,
          default_value: connectorId || ((_c = (_b = inputDefinition == null ? void 0 : inputDefinition.requested_configuration) == null ? void 0 : _b.athena_connector) == null ? void 0 : _c.default_value)
        },
        table_name: {
          ...(_d = inputDefinition == null ? void 0 : inputDefinition.requested_configuration) == null ? void 0 : _d.table_name,
          default_value: tableId || ((_f = (_e = inputDefinition == null ? void 0 : inputDefinition.requested_configuration) == null ? void 0 : _e.table_name) == null ? void 0 : _f.default_value)
        },
        filter_query: {
          ...(_g = inputDefinition == null ? void 0 : inputDefinition.requested_configuration) == null ? void 0 : _g.filter_query,
          default_value: filterQuery || ((_i = (_h = inputDefinition == null ? void 0 : inputDefinition.requested_configuration) == null ? void 0 : _h.filter_query) == null ? void 0 : _i.default_value)
        },
        filter_query_operator: {
          ...(_j = inputDefinition == null ? void 0 : inputDefinition.requested_configuration) == null ? void 0 : _j.filter_query_operator,
          default_value: filterQueryOperator || ((_l = (_k = inputDefinition == null ? void 0 : inputDefinition.requested_configuration) == null ? void 0 : _k.filter_query_operator) == null ? void 0 : _l.default_value)
        }
      } : inputDefinition == null ? void 0 : inputDefinition.requested_configuration;
    },
    [connectorId, tableId, filterQuery, filterQueryOperator, inputDefinition == null ? void 0 : inputDefinition.requested_configuration]
  );
  const createInput = (data) => {
    createInputRequest(data).then(() => {
      onClose();
      history.push(Routes.SYSTEM.INPUTS);
    });
  };
  return /* @__PURE__ */ React.createElement(
    InputForm,
    {
      setShowModal: onClose,
      configFields: externalDataLakeInputFields,
      title: /* @__PURE__ */ React.createElement("span", null, "Launch new ", /* @__PURE__ */ React.createElement("em", null, "External Data Lake Filtered Input")),
      description: inputDefinition == null ? void 0 : inputDefinition.description,
      submitButtonText: "Launch Input",
      typeName: ExternalDataLakeInputType,
      handleSubmit: createInput
    }
  );
};
export default DataLakeConnectorCreateInputModal;
